import { format } from "date-fns";
import theme from "../Shared/ThemeOld/dark";


type saveAsImageProps = {
    name: string;
    date: Date;
}

// @ts-ignore
export const getChartXOptions = (saveAsImageProps: saveAsImageProps) => {
    return {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'cross',
                label: {
                    backgroundColor: '#6a7985'
                }
            }
        },
        toolbox: {
            feature: {
                dataView: { show: false, readOnly: false },
                magicType: { show: false, type: ['line', 'bar'] },
                restore: { show: false },
                saveAsImage: {
                    show: true,
                    name: `${saveAsImageProps.name}-${format(new Date(saveAsImageProps.date), 'yyyy-MM-dd')}`,
                },
            }
        },
        grid: {
            containLabel: true,
            top: 10,
            bottom: 45,
            right: 45,
            left: 2
        },
        label: {
            precision: 1,
            position: 'right',
            valueAnimation: true,
            fontFamily: theme.typography.fontFamily,
        },
        animationDuration: 2000,
    }
};